import Swiper from 'swiper/bundle';
import jQuery from 'jquery';
import 'lazysizes'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Rellax from 'rellax'

// AOS.init({
//     duration: 600,
//     once: true,
//   })

var rellax = new Rellax('.rellax', {
    breakpoints: [550, 768, 940]
});



(function(window, $) {



    "use strict";
    
    
    
    // NAMESPACE
    var app = app || {};
    
    
    
    $('html').removeClass('no-js').addClass('js');
    
    
    
    
    // HELPER
    // TODO: implement debounce function
    
    function scrollToAnchor(href) {
        var anchor = href.substr(href.indexOf('#'));
        var $targetElement = $(anchor);
    
        $('html, body').animate({
            scrollTop: $targetElement.offset().top
        }, 1000);
    }
    
    
    
    // MAIN MENU
    
    app.menu = (function(){
        var $elem = $('#js-main-nav');
        var $toggle = $('#js-nav__toggle');
        var isOpen = false;
        var threshold = 0;
        var init = function() {
            threshold = _calculateNavToggleThreshold();
    
            $toggle.on('click', function(e) {
                e.preventDefault();
                if (isOpen) {
                    close();
                } else {
                    open();
                }
            });
    
            $elem.find('li a').each(function() {
                $(this).on('click', function(e) {
                    let href = this.getAttribute('href');
                    if (href.indexOf('#') === 0) {
                        e.preventDefault();
                        close(function(){scrollToAnchor(href)});
                    }
                });
            });
    
            $(window).on('resize', function(e) {
                threshold = _calculateNavToggleThreshold();
            });
    
        };
        var open = function() {
            $toggle.addClass('is-active');
            $elem.addClass('is-open');
            $('html').css('overflow', 'hidden');
            isOpen = true;
        };
        var close = function(callback) {
            $toggle.removeClass('is-active');
            $elem.removeClass('is-open');
            $('html').css('overflow','auto');
            isOpen = false;
            if (callback !== undefined && typeof callback === 'function') {
                callback();
            }
        };
        var _calculateNavToggleThreshold = function() {
            var $hero = $('#js-hero');
            var $firstSection = $('main section');
    
            if ($hero && $firstSection) {
                return ($hero.height() + $firstSection.height() - $(window).height());
            }
    
            return 0;
        };
        var _toggleNavToggleStyle = function() {
            if (window.scrollY > threshold) {
                $toggle.addClass('nav__toggle--solid');
            } else {
                $toggle.removeClass('nav__toggle--solid');
            }
        };
        return {
            init: init,
            open: open,
            close: close
        };
    })();
    
   
    // SWIPER INITIALIZATION
    
    app.heroSwiper = new Swiper('#js-hero', {
        autoplay: {
            delay: 8000
        },
        speed: 800,
        loop: true,
        lazy: {
            loadPrevNext: true
        },
        preloadImages: false,
        effect: 'fade',
        allowTouchMove: false
    });
    
    app.referencesSwiper = new Swiper('#js-quotes', {
        spaceBetween: 32,
        navigation: {
            prevEl: document.getElementById('js-quote-prev'),
            nextEl: document.getElementById('js-quote-next')
        }
    });
    
    
    
    // BOOTSTRAPPING
    app.menu.init();
    
    
    
    
    // export

    window.app = app;
    
    })(window, jQuery);
    


// WEBPACK FOOTER //
// ./src/js/main.js